import Swiper, { Pagination, Navigation } from 'swiper';
// 使用するコンポーネントの定義
Swiper.use([Pagination, Navigation]);
export const charaSlide = (containerEl) => {
    if (containerEl === null) {
        return;
    }
    const slideEls = containerEl.querySelectorAll('.swiper-slide');
    // Swiperの初期化
    new Swiper(containerEl, {
        centeredSlides: true,
        loop: slideEls.length > 1,
        enabled: slideEls.length > 1,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            771: {
                slidesPerView: 1.5,
            }
        }
    });
    /**
     * スライドが１枚の場合はナビゲーション無効
     */
    if (slideEls.length < 2) {
        const nextEl = containerEl.querySelector('.swiper-button-next');
        if (nextEl !== null) {
            containerEl.removeChild(nextEl);
        }
        const prevEl = containerEl.querySelector('.swiper-button-prev');
        if (prevEl !== null) {
            containerEl.removeChild(prevEl);
        }
    }
};
